<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
              <img src="img/CMU_Logo_Horiz_Red.png"><br>&nbsp;<br>
              <div class="card shadow p-4">
                <div v-html="buildForm()"></div>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        submitForm: Boolean,
        form: String,
      },
      methods: {
        buildForm: function() {
          var formData = JSON.parse(this.form);

          var html = '';

          if(formData.name == 'iota') {
            html += '&nbsp;<br><strong>NOTE: This page is for reviewing the "Internet of Things Assistant" (IoTA) Consent Form.  Actual consent must be given via the app.</strong><br>&nbsp;';
          }

          html += this.getFormHeadingHtml(formData);
          html += this.getFormBodyHtml(formData);
          html += this.getFormQuestionsHtml(formData);

          if(formData.name != 'iota') {
            html += this.getFormButtonHtml(formData);
          }

          return html;
        },
        getFormHeadingHtml: function(formData) {
          return '<h4>' + formData.form_heading + '</h4>';
        },
        getFormBodyHtml: function(formData) {
          var html = '';
          var lastElement = false;
          for(var i=0; i<formData.form_body.length; i++) {
            switch(formData.form_body[i].type) {
              case 'heading':
                html += '<h5>&nbsp;<br><strong>' + formData.form_body[i].text + '</strong></h5>';
                lastElement = 'h5';
                break;
              case 'paragraph':
                html += '<p>' + formData.form_body[i].text + '</p>';
                lastElement = 'p';
                break;
              case 'bullet':
                //if this is the beginning a bulleted list, add the <ul> start tag
                if(lastElement != 'li') {
                  html += '<ul>';
                }

                html += '<li>' + formData.form_body[i].text + '</li>';
                lastElement = 'li';

                //check if we reached the end of the bulleted list, and add the closing </ul> tag
                if(typeof formData.form_body[i+1] === 'undefined' || formData.form_body[i+1].type != 'bullet') {
                  html += '</ul>';
                }

                break;
              default:
                //
            }
          }
          return html;
        },
        getFormQuestionsHtml: function(formData) {
          var html = '';

          for(var i=0; i<formData.form_questions.length; i++) {
            html += '<div class="form-group">';
              html += '<label><strong>' + formData.form_questions[i] + '</strong></label>';
              html += '<div class="form-check">';
                html += '<input class="form-check-input" type="radio" name="radio' + i + '" value="yes">';
                html += '<label class="form-check-label" for="data.value">Yes</label>';
              html += '</div>';
              html += '<div class="form-check">';
                html += '<input class="form-check-input" type="radio" name="radio' + i + '" value="no">';
                html += '<label class="form-check-label" for="data.value">No</label>';
              html += '</div>';
            html += '</div>';
          }

          return html;
        },
        getFormButtonHtml: function(formData) {
          var html = '<p class="pt-4">';

          if(this.submitForm) {
            html += '<button id="continue" type="submit" class="btn btn-success btn-lg" disabled>' + formData.form_button_create_account + '</button>';
          } else {
            html += '<button id="continue" type="button" class="btn btn-success btn-lg" onclick="location.href = ' + "'/irr-consent/agree'" + ';" disabled>' + formData.form_button_agree + '</button>';
            html += '<button id="revoke" type="button" class="btn btn-sm btn-warning float-right" onclick="location.href = ' + "'/revoke-consent-request/create'" + ';" >' + 'Revoke Consent / Delete Account' + '</button>';
          }

          html += '</p>';

          return html;
        },
      },
      mounted() {
        //listen for change on all radio buttons
        //if 4 "yes" are found , enable the continue button
          $(":radio").change(function() {
            var yesCount = 0;
            $(':radio:checked').each(function(){
              if(($(this).val() == 'yes')) {
                yesCount++;
              }
            });

            $('#continue').prop('disabled', (yesCount != 4));

          });

      }
    }
</script>
